if (!customElements.get('cart-drawer-promo-urgency')) {
  class CartDrawerPromoUrgency extends HTMLElement {
    connectedCallback() {
      this.countdownEl = this.querySelector('[data-countdown]');
      this.endTimestamp = Number(this.dataset.endTimestamp);

      if (!this.countdownEl || Number.isNaN(this.endTimestamp)) return;

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    tick() {
      const diff = this.endTimestamp - Date.now();

      if (diff <= 0) {
        this.countdownEl.textContent = '00:00:00';
        if (this.timer) window.clearInterval(this.timer);
        return;
      }

      this.countdownEl.textContent = this.formatCountdown(diff);
    }

    formatCountdown(ms) {
      const totalSeconds = Math.floor(ms / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const time = [hours, minutes, seconds]
        .map((value) => String(value).padStart(2, '0'))
        .join(':');

      return days > 0 ? `${days}d ${time}` : time;
    }
  }

  customElements.define('cart-drawer-promo-urgency', CartDrawerPromoUrgency);
}
